import React from 'react';
import { useLabels } from 'ws-scripts/modules/common';

import useMyCarsCta from '../hooks/useMyCarsCta';
import useMyWalletCta from '../hooks/useMyWalletCta';
import CTAButton from './CTAButton';

/**
 * DrawerCTAButtons — pure layout composing the My Cars and My Wallet CTA
 * buttons. All gating and click-handling logic lives in useMyCarsCta and
 * useMyWalletCta; this component only decides whether to render at all
 * (neither button enabled -> render nothing, since DrawerPanelBody mounts
 * this component unconditionally and there's no parent left to gate it) and
 * lays the two buttons out.
 */
const DrawerCTAButtons = () => {
	const labels = useLabels();
	const myCars = useMyCarsCta();
	const myWallet = useMyWalletCta();

	if (myCars.isEnabled === false && !myWallet.isEnabled) return null;

	return (
		<div
			className="ws-nav-drawer__cta-buttons d-flex py-5 px-4"
			data-testid="drawer-cta-buttons"
		>
			{myCars.isEnabled && (
				<CTAButton
					ref={myCars.buttonRef}
					iconClass="ddc-icon-mycars-login"
					label={labels.get('MY_CARS')}
					testId="drawer-cta-mycars"
					onClick={myCars.handleClick}
					disabled={myCars.isDisabled}
				/>
			)}
			{myWallet.isEnabled && (
				<CTAButton
					iconClass="ddc-icon-mywallet"
					label={labels.get('MY_WALLET')}
					testId="drawer-cta-mywallet"
					onClick={myWallet.handleClick}
					disabled={myWallet.isDisabled}
				/>
			)}
		</div>
	);
};

export default DrawerCTAButtons;
